import { __assign } from "tslib";
import dayjs from '../dayjs';
export var defaultDisabledTime = {
    disabledHours: function () {
        return [];
    },
    disabledMinutes: function () {
        return [];
    },
    disabledSeconds: function () {
        return [];
    },
};
export function getTodayTime(value) {
    var today = dayjs();
    today.locale(value.locale()).utcOffset(value.utcOffset());
    return today;
}
export function getTitleString(value) {
    return value.format('LL');
}
export function getTodayTimeStr(value) {
    var today = getTodayTime(value);
    return getTitleString(today);
}
export function getMonthName(month) {
    var locale = month.locale();
    var localeData = month.localeData();
    return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
}
export function syncTime(from, to) {
    if (!dayjs.isDayjs(from) || !dayjs.isDayjs(to)) {
        return;
    }
    to.hour(from.hour());
    to.minute(from.minute());
    to.second(from.second());
    to.millisecond(from.millisecond());
}
export function getTimeConfig(value, disabledTime) {
    return __assign(__assign({}, defaultDisabledTime), disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(value));
}
export function isTimeValidByConfig(value, disabledTimeConfig) {
    if (!value) {
        return true;
    }
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    return disabledTimeConfig.disabledHours().indexOf(hour) === -1
        && disabledTimeConfig.disabledMinutes(hour).indexOf(minutes) === -1
        && disabledTimeConfig.disabledSeconds(hour, minutes).indexOf(seconds) === -1;
}
export function isTimeValid(value, disabledTime) {
    var disabledTimeConfig = getTimeConfig(value, disabledTime);
    return isTimeValidByConfig(value, disabledTimeConfig);
}
export function isAllowedDate(value, disabledDate, disabledTime) {
    if ((disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(value)) || (disabledTime && !isTimeValid(value, disabledTime))) {
        return false;
    }
    return true;
}
export function formatDate(value, format) {
    if (!value) {
        return '';
    }
    return value.format(Array.isArray(format) ? format[0] : format);
}
